(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/challenge/assets/javascripts/components/play-container_desktop.js') >= 0) return;  svs.modules.push('/modules/challenge/assets/javascripts/components/play-container_desktop.js');
"use strict";


const {
  userSession
} = svs.core;
const {
  helpers
} = svs.challenge;
const {
  withRouter
} = ReactRouterDOM;
const {
  MultiSwiper
} = svs.components;
const {
  OverviewDimmer,
  Play
} = svs.challenge;
const {
  CampaignFlerp
} = svs.components.lbUi.campaignFlerp;
const {
  BigStat
} = svs.components.sportinfo.bigstat;
const productIds = svs.utils.products.productIds;
const {
  SportTypes
} = svs.components.sport.sportTypes;
class PlayContainer extends React.Component {
  constructor() {
    super();
    this.updateMultipSwiper = this.updateMultipSwiper.bind(this);
  }
  componentDidMount() {
    const {
      selectedDraw
    } = this.props;
    svs.sport.sport_common.checkExclusionOnVertical();

    if (svs.utils.ns.isNamespace('svs.core.config.data.svsconfig.isSelfService') && svs.core.config.data.svsconfig.isSelfService === true) {
      document.querySelector('.selfservice-nav-btn').innerHTML = '<a href="/challenge" class="btn btn-100 btn-transparent-inverted" title="Till Challenge start"><span class="btn-link-text">Challenge start</span></a>';
    }
    if (userSession.hasRole(userSession.roles.PLAYER)) {
      helpers.initiateAccountSelector(selectedDraw.drawNumber, selectedDraw.productId);
    }
  }
  componentDidUpdate(prevProps) {
    const {
      selectedDraw
    } = this.props;
    if (prevProps.selectedDraw !== selectedDraw) {
      svs.components.marketplace.accountSelector.helpers.observer.notify(selectedDraw.drawNumber, selectedDraw.productId);
      svs.components.marketplace.accountSelector.helpers.fetchGames({
        drawNumber: selectedDraw.drawNumber,
        productId: selectedDraw.productId
      });
    }
  }
  componentWillUnmount() {
    if (svs.utils.ns.isNamespace('svs.core.config.data.svsconfig.isSelfService') && svs.core.config.data.svsconfig.isSelfService === true) {
      document.querySelector('.selfservice-nav-btn').innerHTML = '<a href="/" class="btn btn-100 btn-transparent-inverted" title="Till Start"><span class="btn-link-text">Till Start</span></a>';
    }
  }
  handleMultiSwipe() {
    if (this.multiSwiper) {
      this.updateMultipSwiper();
    } else {
      const multiSwiperOptions = {
        scrollerOptions: [{
          nodeId: 'coupon-holder',
          toSubtract: ['#top-content', '#draw-selector', '#selfservice-container', '.js-selfservice-mini-cart']
        }, {
          noScroller: true,
          nodeId: 'challenge-right-side',
          toSubtract: ['#top-content', '#selfservice-container']
        }]
      };
      this.multiSwiper = new MultiSwiper(multiSwiperOptions);
      this.multiSwiper.init();
    }
  }
  updateMultipSwiper() {
    this.multiSwiper.updateSize();
  }
  render() {
    const {
      selectedDraw,
      selectedEvent,
      selectedMatchId
    } = this.props;
    const isSpecialTrotting = svs.challenge.data && svs.challenge.data.config && svs.challenge.data.config.specialTrottingEvent && svs.challenge.data.config.specialTrottingEvent.drawNumber === selectedDraw.drawNumber;
    return React.createElement("div", {
      className: "grid-row"
    }, React.createElement(OverviewDimmer, null), React.createElement(CampaignFlerp, {
      branding: "challenge"
    }), React.createElement("div", {
      className: "col-sm-6 col-md-4 col-lg-4 col-xl-3 challenge-left-side",
      id: "challenge-left-side"
    }, React.createElement(Play, {
      updateMultipSwiper: () => {
      }
    })), React.createElement("div", {
      className: "col-sm-6 col-md-8 col-lg-8 col-xl-9 bigstat-container bigstat-right-side-content",
      id: "challenge-right-side"
    }, selectedEvent && selectedMatchId && React.createElement(BigStat, {
      activeTabBasePaths: ["".concat(svs.challenge.helpers.correctDrawUrl(selectedDraw, selectedEvent === null || selectedEvent === void 0 ? void 0 : selectedEvent.eventNumber, undefined, false))],
      basePath: "".concat(svs.challenge.helpers.correctDrawUrl(selectedDraw, selectedEvent === null || selectedEvent === void 0 ? void 0 : selectedEvent.eventNumber), "/"),
      branding: "challenge",
      classNameWrapper: "big-stat",
      drawNumber: selectedDraw.drawNumber,
      forceSportType: isSpecialTrotting ? SportTypes.Trotting : undefined,
      isEnclosedInRouter: true,
      isWideDevice: !svs.core.detect.formfactor.mobile(),
      matchId: selectedMatchId,
      productId: productIds.CHALLENGE,
      theme: "DARK"
    })));
  }
}
const mapStateToProps = (state, _ref) => {
  var _Number;
  let {
    match
  } = _ref;
  const drawNumber = Number(match.params.drawNumber);
  const eventNumber = ((_Number = Number(match.params.eventNumber)) !== null && _Number !== void 0 ? _Number : 1) - 1; 

  const selectedDraw = svs.challenge.helpers.getDrawByDrawNumber(drawNumber, state);
  const selectedEvent = selectedDraw === null || selectedDraw === void 0 ? void 0 : selectedDraw.drawEvents[eventNumber];
  const selectedMatchId = selectedEvent === null || selectedEvent === void 0 ? void 0 : selectedEvent.match.matchId;
  return {
    selectedDraw,
    selectedEvent,
    selectedMatchId
  };
};
svs.challenge.PlayContainer = withRouter(ReactRedux.connect(mapStateToProps)(PlayContainer));

 })(window);